import styles from "./FoundersMessage.module.css";
import { unknownCompany } from "../../../../constants/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export default function FoundersMessage({ setUwCompany }) {
  return (
    <div className={styles.foundersMessage}>
      <div className={styles.messageBox}>
        <div className={styles.iconAlign}>
          <span onClick={() => setUwCompany(unknownCompany)}>Close</span>
          <FontAwesomeIcon
            onClick={() => setUwCompany(unknownCompany)}
            className={styles.icon}
            icon={faTimesCircle}
          />
        </div>
        <p>
          Please click the button below to access the Founders Insurance Claims Portal to
          get started.
        </p>
        <a href="https://myaccount.foundersinsurance.com/MVC/OnlineLossPublic/Home/Index">
          Go to Founders Insurance Claims Portal
        </a>
        <p>Thank you.</p>
      </div>
    </div>
  );
}
